// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-text-field .v-label a{pointer-events:all}.otp{position:relative}.otp .v-text-field input{max-width:55%}.otp .otp__resend{position:absolute;right:61px;top:19px}.otp .otp__resend a{color:#5e5e5e}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
